module.exports = __webpack_public_path__ + "img/net.6f289a5a.jpg";